import React from "react";
import { usePopup } from "./PopupProvider";
import { RefreshCw } from "lucide-react";
import { clearApiResponseCache } from "../utils/apiCache";

const DataRefreshButton = ({ className = "", style }) => {
  const { showConfirm } = usePopup();
  return (
  <button
    type="button"
    aria-label="Refresh data"
    title="Refresh data"
    onClick={async () => {
      if (!await showConfirm("The page will reload. Unsaved changes may be lost.", "Refresh page?", { confirmLabel: "Refresh page" })) return;
      clearApiResponseCache();
      window.__bqSkipRefreshPrompt = true;
      window.location.reload();
    }}
    className={className}
    style={style}
  >
    <RefreshCw size={16} />
  </button>
);
};

export default DataRefreshButton;
